
export default {
    props: {
        step: { type: Number, required: true },
        total: { type: Number, required: true },
        label: { type: String, default: '' },
        // Mirror FooterNav's, so a step that hides one nav hides it in both
        // places rather than offering an action at the top that the bottom
        // withholds (e.g. the sign step, where the SOA owns the terminal action).
        hideBack: { type: Boolean, default: false },
        hideNext: { type: Boolean, default: false },
        nextLabel: { type: String, default: 'Next' },
    },
    computed: {
        autosave () { return this.$store.state.autosave },
        chipClass () {
            return { show: true, saving: this.autosave === 'saving', errored: this.autosave === 'errored' }
        },
        chipText () {
            if (this.autosave === 'saving') { return 'Saving…' }
            if (this.autosave === 'errored') { return 'Could not save — check your connection' }
            return 'All changes saved'
        },
    },
}
